import MenuBookIcon from "@mui/icons-material/MenuBook";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { useState, useEffect } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import {
  deleteTipoContenidos,
  getTipoContenidosPaginated,
  getTiposContenidos,
  postTipoContenidos,
} from "../helpers/TipoContenidosData";
import { FormTiposContenidos } from "../components/FormTiposContenidos";
import { MetadatosList } from "../components/MetadatosList";
import { Grid, Tooltip, useTheme, useMediaQuery, IconButton } from "@mui/material";
import { GenericCard } from "src/general_components/GenericCard";
import { SimpleDialogComponent } from "src/general_components/SimpleDialogComponent";
import { CajasProvider } from "src/context/CajasContext/CajasContext";
import BuscarFormTipoContenidos from "../components/BuscarFormTipoContenidos";
import Button from '@mui/material/Button';
import SearchIcon from "@mui/icons-material/Search";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import MenuBookIcon2 from "@mui/icons-material/LibraryBooks";

export const TipoContenidosList = () => {
  const [createButton, setCreateButton] = useState(false);
  const [buttonMetadatos, setButtonMetadatos] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [labelModal, setLabelModal] = useState("Metadatos del tipo de contenido: ");
  const [modalStateSearch, setModalStateSearch] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [labelModalSearch, setLabelModalSearch] = useState("Buscar");
  const [filtros, setFiltros] = useState(null);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [tipoContenidos, setTipoContenidos] = useState([]);
  const listName = "Tipos de Contenidos";
  const columns = [
    { field: "id", headerName: "ID", flex: 0.2 }, // la propiedad flex permite setear responsivamente el tamaño de la columna
    { field: "detalle", headerName: "Detalle", flex: 1 }, // la misma se divide entre el total y el porcentaje que le asiganas con un numero
    {
      field: "Metadatos",
      headerName: "Ver Metadatos",
      type: "actions",
      flex: 0.3,
      getActions: (params) => [
        <GridActionsCellItem
          icon={
            <Tooltip title="Ver Metadatos">
              <span>
                <MenuBookIcon color="primary" />
              </span>
            </Tooltip>
          }
          onClick={() => {
            verMetadatos(params);
            setModalState(true);
          }}
          label="MenuBookIcon"
        />,
      ],
    },
  ];

  const handleDelete = async (id) => {
    const success = await deleteTipoContenidos(id);
    if (success) {
      window.location.reload();
    }
  };

  const mobileComponent = ({ row }) => (
    <GenericCard
      row={row}
      columns={columns}
      onEdit={(item) => {
        setTipoContenidos(item);
        setCreateButton(true);
      }}
      onDelete={handleDelete}
      customActions={
        <IconButton onClick={() => { verMetadatos({ row }); setModalState(true); }} size="small" color="primary">
          <MenuBookIcon />
        </IconButton>
      }
    />
  );

  const toggleModalMetadatos = () => {
    setModalState(!modalState);
  };

  const toggleModalSearch = () => {
    setModalStateSearch(!modalStateSearch);
  };

  const verMetadatos = async (data) => {
    setTipoContenidos(data.row);
    setButtonMetadatos(true);

  };

  useEffect(() => {
    setLabelModal("Metadatos del tipo de contenido: " + tipoContenidos.detalle)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipoContenidos]);

  useEffect(() => {
    setOptions({ ...options, refresh: refreshList, idElementData: filtros })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshList, filtros]);

  const [options, setOptions] = useState({
    cols: columns,
    get: getTiposContenidos,
    getPaginated: getTipoContenidosPaginated,
    //pageSize: [5, 10, 25],
    edit: true,
    delete: deleteTipoContenidos,
    limit: 50,
    filter: true,
    exportData: true,
    server: true,
    idElementData: filtros,

    //DATOS PARA EL FORMULARIO
    createButton: createButton,
    setCreateButton: setCreateButton,
    setDataEdit: setTipoContenidos,

    mobileComponent: mobileComponent,
  });

  //CONTROLA CUANDO SE SALE DE UN EDITAR PARA LIMPIAR LA VARIABLE, GUARDA CON EL ID, PUEDE SER QUE EN ALGUNOS NO FUNCIONE
  //TODOS LOS EDITAR DEBERIAN DE TENER UN ID, PERO POR LAS DUDAS COMPROBAR.
  //EL BUTTONMETADATOS SOLO ES PARA ESTE CASO, VERIFICAR CADA OCASION.
  if (
    createButton === false &&
    tipoContenidos.id !== undefined &&
    buttonMetadatos === false
  ) {
    setTipoContenidos([]);
  }
  //setLabelModal("Metadatos del tipo de contenido: " + tipoContenidos.detalle)

  const mobileTopButtons = isMobile && (
    <Grid container justifyContent="center" spacing={2} mb={2} mt={1}>
      <Grid item xs={6}>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          startIcon={<SearchIcon />}
          onClick={() => setModalStateSearch(true)}
          style={{ fontSize: "11px", height: "30px", fontFamily: 'Roboto, sans-serif' }}
        >
          Buscar
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={() => { setCreateButton(true); setTipoContenidos([]); }}
          style={{ fontSize: "11px", height: "30px", fontFamily: 'Roboto, sans-serif', color: '#FFFFFF' }}
        >
          Añadir
        </Button>
      </Grid>
    </Grid>
  );

  return (



    <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
      <PageHeaderCard title={listName} icon={<MenuBookIcon2 />} />
      {mobileTopButtons}
      <CajasProvider>
        <>
          {!isMobile && (
            <Grid container justifyContent="flex-end" mb={2} mt={2}>
              <Button
                endIcon={<SearchIcon />}
                onClick={() => {
                  setModalStateSearch(true);
                }}
                variant="contained"
                style={{
                  color: '#FFFFFF',
                  fontFamily: 'Roboto, sans-serif',
                  minWidth: '120px',
                  width: '120px',
                  fontSize: '11px',
                  height: '30px',
                }}
              >
                Buscar
              </Button>
            </Grid>
          )}

          <SimpleDialogComponent
            open={modalState}
            modalName={labelModal}
            child={
              <MetadatosList
                tipoContenido={tipoContenidos}
                setButtonMetadatos={setButtonMetadatos}
                setRefreshList={setRefreshList}
              />}
            handleClose={toggleModalMetadatos}
            buttonEnviar={false}
            buttonCancelar={true}
          />

          <SimpleDialogComponent
            open={modalStateSearch}
            modalName={labelModalSearch}
            child={
              <BuscarFormTipoContenidos
                setModalState={setModalStateSearch}
                setFiltros={setFiltros}
              />}
            handleClose={toggleModalSearch}
            buttonEnviar={false}
            buttonCancelar={true}
          />

          <>
            <ListTablePaginated options={options} />
            <FormTiposContenidos
              data={tipoContenidos}
              createButton={createButton}
              listName={listName}
              setCreateButton={setCreateButton}
              componentList={"/tipo_contenidos/admin"}
              postData={postTipoContenidos}
            />
          </>
        </>
      </CajasProvider>
    </Grid>
  );
};